const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/generateMetaKatDropDownField.tsx';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { MessageDescriptor } from '@formatjs/intl';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';

interface Props {
    label: string | MessageDescriptor;
    path: string;
    hidden?: boolean;
    required?: boolean;
}

export const generateMetaKatDropDownField = (pcode: string, displayName?: string) => {
    const Component = forwardRef<unknown, Props>(({ label, path, hidden = false, required = false }, ref) => {
        const { formatMessage, locale } = useIntl();
        const dropdownRef = useCIS4m(ref);
        const resolvedLabel = typeof label === 'string' ? label : formatMessage(label);

        return (
            <CIS4mMetaKatDropDown
                ref={dropdownRef}
                label={resolvedLabel}
                path={path}
                pcode={pcode}
                valuePath="FKEY"
                labelPath={`CONTENT.Lang.${locale}`}
                hidden={hidden}
                required={required}
                dataHook={useCIS4FormMetaKatData}
            />
        );
    });

    Component.displayName = displayName || `MetaKatDropDownField(${pcode})`;
    return Component;
};
